import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input, Injector } from '@angular/core';
import { fadeInAnimation, fadeInOut } from '../../../common/service/routerTransition';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EventManagerService } from 'src/app/common/service/event-manager.service';
import { CopyProperties } from 'src/app/common/decorator/copy-properties.decorator';
@Component({
    selector: 'detail-fee',
    templateUrl: './detail-fee.html',
    styleUrls: ['./detail-fee.scss'],
    animations: [fadeInAnimation, fadeInOut],
    host: { '[@fadeInAnimation]': '' }
})

export class DetailFee  implements OnInit {
    @Input('option') option :OptionFee;
    @Input('fees') fees;
    constructor(
        private eventManager: EventManagerService,
        public activeModal: NgbActiveModal,
        public modalService: NgbModal,) {
    }
    ngOnInit() {
    }
    dismiss() {
        this.activeModal.dismiss();
    }
}
@CopyProperties()
export class OptionFee {
    valueTitle: string;
    valueUnit: string;
    feeTitle: string;
    feeUnit: string;
    constructor(params?: any) {
        this.valueTitle = '';
        this.valueUnit = '';
        this.feeTitle = '';
        this.feeUnit = '';
    }
}